import { API_BASE } from '@/common/constants';
import storage from '@/common/storage';
import axios from 'axios';

export default async function dupOwnerLogin(mail) {
  if (storage.isOwnerLogin(mail)) {
    if (!window.confirm('多重ログインです。ログアウトしますか？')) {
      return;
    }
    const bc = new BroadcastChannel('fcti2');
    await axios.post(`${API_BASE}/owner/init`, {
      method: 'logout',
    }, {
      withCredentials: true,
      timeout: 60 * 1000,
      validateStatus: () => true,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded',
      },
    });
    bc.postMessage({
      type: 'OWNER_LOGOUT',
    });
    await new Promise(r => setTimeout(r, 1000));
  }
  storage.setOwnerLogin(mail);
}